import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /** The daytime grade (render/passes/dayGrade.ts): 0 off, 1 soft, 2 medium. */
    dayGradeLevel: number;
  }
}

defineSetting({
  key: 'dayGradeLevel',
  default: 2,
  order: 101,
  menu: {
    group: 'visual',
    label: 'โทนแสงกลางวัน',
    choices: ['ปิด', 'อ่อน', 'กลาง'],
    note: () => 'แสงอุ่นสลับเงาเย็น เงาเมฆลอยผ่าน แสงลอดเมฆ และขอบภาพมืดเล็กน้อย (เฉพาะตอนกลางวัน)',
  },
});
